export default __webpack_public_path__ + "static/media/img-11.a7121c9a.png";